export enum WREX_LINK_PREVIEW {
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=524253687
     */
    EDIT_RESOURCE_PREVIEW = 'WREX_LINK_PREVIEW.EDIT_RESOURCE_PREVIEW',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=409367556
     */
    INSERT_RESOURCE = 'WREX_LINK_PREVIEW.INSERT_RESOURCE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=232963462
     */
    RESOURCE = 'JOURNEYS_CORE.RESOURCE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=792104466
     */
    RESOURCE_NOT_HANDLED = 'RESOURCES.RESOURCE_NOT_HANDLED',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=822221983
     */
    TOOLBAR = 'WREX_LINK_PREVIEW.TOOLBAR',
}
